<template>
  <PopUp
    v-if="isActive"
    unbottom
    :title="fetchedArticle.name"
    :isLoading="isLoading"
    :popUpActive="isActive"
    @click="$_onClosePopup"
  >
    <LvInfoArticle
      isShowContent
      contentPadding="0"
      :name="fetchedArticle.name"
      :richContent="fetchedArticle.richContent"
      :content="fetchedArticle.content"
    />
  </PopUp>
</template>

<script>
import S_scope from '@/service/api/v1/scope';
import S_guidelineArticleVersion from '@/service/api/v1/guidelineArticleVersion';
import H_act from '@/helpers/act';
import H_guidelineArticleVersionAdmin from '@/helpers/guidelineArticleVersionAdmin';

export default {
  data() {
    return {
      isActive: false,
      isLoading: false,
      fetchedArticle: {},
    };
  },
  computed: {
    _scopeActRead() {
      return S_scope.$_isAvailable(['act-read']);
    },
    _scopeTaskRead() {
      return S_scope.$_isAvailable(['task-read']) || S_scope.$_isAvailable(['task-read-all']);
    },
  },
  methods: {
    async $_onOpenPopup(article, $event = {}) {
      const { articleVerId, guideline_article_version, guideline_article } = $event;
      this.isActive = true;
      if (article) {
        this.fetchedArticle = article;
      } else if (articleVerId) {
        this.isLoading = true;
        const rawData = await S_guidelineArticleVersion.show(articleVerId);
        this.fetchedArticle = H_guidelineArticleVersionAdmin.setShow(rawData);
        this.fetchedArticle.name =
          guideline_article_version &&
          guideline_article_version.guideline_version &&
          guideline_article_version.guideline_version.name
            ? `${guideline_article_version.guideline_version.name} ${this.fetchedArticle.name}`
            : guideline_article &&
              guideline_article.last_version &&
              guideline_article.last_version.guideline_version
            ? `${guideline_article.last_version.guideline_version.name} ${this.fetchedArticle.name}`
            : this.fetchedArticle.name;
        this.isLoading = false;
      } else this.isActive = false;
    },
    $_onClosePopup() {
      this.isActive = false;
      this.isLoading = false;
      this.fetchedArticle = {};
    },
    $_getRelatedFieldList(versionData, type) {
      const result = [];
      const keyList = {
        guideline: ['guideline_version', 'guideline_article_version'],
        task: ['task'],
      };
      const fieldKeyList = keyList[type] || [
        'license',
        'checklist',
        'audit',
        'contractor_license',
        'internal_training',
      ];
      const relatedFieldsList = H_act.getRelatedFieldsList(this.$route.fullPath);
      fieldKeyList.forEach(key => {
        if (versionData[`has_${key}`])
          result.push(relatedFieldsList.find(field => field.modelName === key));
      });
      return result;
    },
  },
};
</script>
